"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable dot-notation */
const react_1 = __importStar(require("react"));
const Widget_1 = __importDefault(require("~/components/UI/Widget"));
const Input_1 = __importDefault(require("~/components/UI/Input"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const selectors_1 = require("~/store/selectors");
const consts_1 = require("~/store/consts");
const actions_1 = require("~/store/actions");
const redux_1 = require("redux");
const CatalogWidget_module_scss_1 = __importDefault(require("./CatalogWidget.module.scss"));
const Catalog_1 = __importDefault(require("./Catalog/Catalog"));
const Search_1 = require("./Search");
function CatalogWidget() {
    const { t } = (0, react_i18next_1.useTranslation)('catalog-widget');
    const [widgetMode, setWidgetMode] = (0, react_1.useState)('catalog');
    const [searchValue, setSearchValue] = (0, react_1.useState)('');
    const isBOMEditMode = (0, react_redux_1.useSelector)(selectors_1.selectBOMEditMode);
    const { dispatchRequestCatalog, dispatchRequestCatalogMeta } = (0, redux_1.bindActionCreators)({
        dispatchRequestCatalog: actions_1.requestCatalog,
        dispatchRequestCatalogMeta: actions_1.requestCatalogMeta,
    }, (0, react_redux_1.useDispatch)());
    (0, react_1.useEffect)(() => {
        dispatchRequestCatalogMeta();
        dispatchRequestCatalog();
    }, []);
    const searchHandler = (value) => {
        if (value) {
            setWidgetMode('search');
        }
        else if (isBOMEditMode) {
            setWidgetMode('bom-editor');
        }
        else {
            setWidgetMode('catalog');
        }
        setSearchValue(value);
    };
    return (react_1.default.createElement(Widget_1.default, { widgetName: isBOMEditMode ? consts_1.WIDGETS.CATALOG_WIDGET_EDIT_MODE : consts_1.WIDGETS.CATALOG_WIDGET, defaultSize: {
            width: 343,
            height: 595,
        }, minSize: {
            width: 343,
            height: 355,
        } },
        react_1.default.createElement("div", { className: CatalogWidget_module_scss_1.default['content'], id: "widget-content" },
            react_1.default.createElement(Input_1.default, { type: "search", onChange: searchHandler, placeholder: t('search-input') }),
            widgetMode === 'catalog' || widgetMode === 'bom-editor' ? react_1.default.createElement(Catalog_1.default, null) : null,
            widgetMode === 'search' ? react_1.default.createElement(Search_1.Search, { value: searchValue }) : null)));
}
exports.default = CatalogWidget;
